import { useConfirmPage } from "./logic";
import { ConfirmPageTemplate } from "./template";

export const ConfirmPage = (): JSX.Element => {
  const data = useConfirmPage();
  return <ConfirmPageTemplate {...data} />;
};
